import type { TextProps } from "./types";
import { forwardRef } from "react";
import { useStyles } from "./styles";

const variantToElement = {
  body: "p",
  label: "label",
  caption: "span",
  overline: "span",
} as const;

export const Text = forwardRef<HTMLElement, TextProps>(
  ({ variant = "body", as, style, className, ...rest }, ref) => {
    const styles = useStyles({
      variant,
      ...rest,
    });

    const Component = as || variantToElement[variant] || "span";

    // These props are used by useStyles via ...rest, but need to be excluded from domProps
    /* eslint-disable @typescript-eslint/no-unused-vars */
    const {
      color: _color,
      weight: _weight,
      align: _align,
      size: _size,
      ellipsis: _ellipsis,
      numberOfLines: _numberOfLines,
      ...domProps
    } = rest;
    /* eslint-enable @typescript-eslint/no-unused-vars */

    if ("dangerouslySetInnerHTML" in domProps) {
      return (
        <Component
          ref={ref}
          {...domProps}
          className={`typography-text ${className ?? ""}`}
          style={{ ...styles, ...style }}
          dangerouslySetInnerHTML={domProps.dangerouslySetInnerHTML}
        />
      );
    }

    return (
      <Component
        ref={ref}
        {...domProps}
        className={`typography-text ${className ?? ""}`}
        style={{ ...styles, ...style }}
      >
        {domProps.children}
      </Component>
    );
  },
);

Text.displayName = "Text";
